<script setup lang="ts">
import Button from './Button.vue';
import { useSessionStore, useUserStore } from '../../stores';
import FullscreenIcon from '../../assets/icons/fullscreen.svg';
import { UserRole } from '../../types/user';

interface Props {
    togglePosition?: 'top-right' | 'bottom-right' | 'bottom-left' | 'top-left'
}
const { togglePosition = 'top-right' } = defineProps<Props>()

const sessionStore = useSessionStore()
const user = useUserStore()

function toggleFullscreen() {
    sessionStore.isFullscreen = !sessionStore.isFullscreen
}
</script>

<template>
    <div :class="{
        'fixed top-0 left-0 !size-full !m-0 !p-3 bg-white z-20': sessionStore.isFullscreen,
        'relative': !sessionStore.isFullscreen
    }">
        <Button v-if="user.userRole === UserRole.teacher || !sessionStore.teacherSession" color="light" size="small"
            class="!px-2 absolute z-10" :class="{
                'top-1 right-1': togglePosition === 'top-right',
                'bottom-1 right-1': togglePosition === 'bottom-right',
                'bottom-1 left-1': togglePosition === 'bottom-left',
                'top-1 left-1': togglePosition === 'top-left'
            }" :border="false" @click="toggleFullscreen">
            <FullscreenIcon class="size-4 text-black" />
        </Button>
        <slot></slot>
    </div>
</template>